<template>
  <div id='todo-main'>
    <h1 style="text-align:center;">{{ userCurrentTodo.title }}</h1>
    <p style="width: 80%; margin-left: 10%;">{{ userCurrentTodo.content }}</p>
    <p style="width: 80%; margin-left: 10%;" v-for="(attach, index) in userCurrentTodo.attachments" :key="attach">
      <a v-if="attach.length > 0" :href="attach" target="_blank">附件 {{ index + 1}}</a>
    </p>
    <p v-if="userCurrentTodo.tid.length > 0" style="text-align:center; font-size: 10px; color: gray;">到期时间: {{ userCurrentTodo.timestamp }}</p>
    <div style="text-align:center; margin-top: 20px;">
      <el-button type="primary" size="mini" @click="handleCreateTodo">{{ $t('createTodo') }}</el-button>
      <!-- TODO: 因rabbitmq不支持消息修改和删除，暂时注释的编辑和删除功能 -->
      <!-- <el-button v-if="userCurrentTodo.tid.length > 0" type="success" size="mini" @click="handleUpdateTodo">{{ $t('editTodo') }}</el-button> -->
      <el-button v-if="userCurrentTodo.tid.length > 0 && isOutDated(userCurrentTodo)" type="danger" size="mini" @click="handleDeleteTodo">{{ $t('deleteTodo') }}</el-button>
    </div>
    <el-empty v-if="userCurrentTodo.tid === ''" description="空"></el-empty>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import bus from '@/util/eventbus'
const constants = require('@/util/constants')

export default {
  name: 'todo-main',
  computed: {
    ...mapGetters([ 'userCurrentTodo' ]),
  },
  methods: {
    isOutDated (todo) {
      let now = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
      let endAt = moment(todo.timestamp).format('YYYY-MM-DD HH:mm:ss')
      if (now > endAt) {
        return true
      }
      return false
    },
    handleCreateTodo () {
      bus.$emit(constants.EVENT_BUS_CREATE_TODO)
    },
    handleUpdateTodo () {
      bus.$emit(constants.EVENT_BUS_UPDATE_TODO)
    },
    handleDeleteTodo () {
      bus.$emit(constants.EVENT_BUS_DELETE_TODO)
    }
  }

}
</script>

<style scoped>
#todo-main {
  padding-left: 10px;
  padding-top: 50px;
  text-align: left;
  height: 100%;
  width: 100%;
}
</style>
